<template>
  <div class="ui-blocker" v-if="isShow">
    <div class="ui-blocker-wait">
      <i class="fas fa-spinner fa-spin"></i>
      <span><slot></slot></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "UIBlocker",
  props: {
    isShow: { type: Boolean, default: false, required: true },
  },
};
</script>

<style scoped>
.ui-blocker {
  background-color: rgba(0, 0, 0, 0.7);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ui-blocker-wait {
  background-color: #f2f2f2;
  position: relative;
  width: 300px;
  height: 100px;
  display: flex;
  padding: 10px;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
}

.ui-blocker-wait span {
  margin-left: 5px;
}
</style>